import * as React from "react";
import { Context } from "@grandvisionhq/carts-v2";
import { toast } from "@grandvisionhq/common";
import { useIntl, useSelector } from "@grandvisionhq/state";
import { getSelectedPickupPoint, getSelectedStore } from "../../../../../../../../../../StepShipping/StepShipping/selectors.js";
import { mapApplePayContactAddress } from "../../../../../../mappers/modules/ExpressCheckout/hooks/apple-pay/mappers/apple-pay-contact-address.js";
import { mapAndMergeApplePayShippingContactWithBillingContact } from "../../../../../../mappers/modules/ExpressCheckout/hooks/apple-pay/mappers/merge-apple-pay-contact-and-billing-address.js";
import { ApplePaySessionErrors } from "../../../../../../../../../../mappers/mappers/errors-mapping.js";
import { isNearestPickup, isPickupPoint, isPickupStore } from "../../../../../../../../../../utils/utils/shipping-method.js";
const useMapShippingAddress = () => {
  const { country, getLabel } = useIntl();
  const { cart } = Context.useCart();
  const selectedPickupPoint = useSelector(getSelectedPickupPoint);
  const selectedStore = useSelector(getSelectedStore);
  return React.useCallback(
    (applePayment) => {
      if (!applePayment.billingContact) {
        return;
      }
      const isNearestPickup$1 = isNearestPickup(cart?.shippingMethod.key);
      const isPickupPoint$1 = isPickupPoint(cart?.shippingMethod.key);
      const isStorePickUp = isPickupStore(cart?.shippingMethod.key);
      if (isNearestPickup$1) {
        if (applePayment.billingContact.countryCode !== country) {
          toast.failed(ApplePaySessionErrors.ApplePayInvalidAddress);
          throw getLabel(ApplePaySessionErrors.ApplePayInvalidAddress);
        }
        return mapApplePayContactAddress(applePayment.billingContact);
      }
      if (!applePayment?.shippingContact) {
        return;
      }
      if (isPickupPoint$1) {
        const mappedAndMergedShippingAddress = mapAndMergeApplePayShippingContactWithBillingContact(
          applePayment.shippingContact,
          applePayment.billingContact
        );
        if (mappedAndMergedShippingAddress && !!selectedPickupPoint?.globalPickupPointId) {
          mappedAndMergedShippingAddress.externalId = selectedPickupPoint?.globalPickupPointId;
        }
        mappedAndMergedShippingAddress.company = selectedPickupPoint?.name;
        return mappedAndMergedShippingAddress;
      }
      if (isStorePickUp) {
        const mappedAndMergedShippingAddress = mapAndMergeApplePayShippingContactWithBillingContact(
          applePayment.shippingContact,
          applePayment.billingContact
        );
        if (mappedAndMergedShippingAddress && !!selectedStore?.globalStoreId) {
          mappedAndMergedShippingAddress.externalId = selectedStore.globalStoreId;
        }
        mappedAndMergedShippingAddress.company = selectedStore?.name;
        return mappedAndMergedShippingAddress;
      }
      return mapApplePayContactAddress(applePayment?.shippingContact);
    },
    [
      cart?.shippingMethod.key,
      country,
      getLabel,
      selectedPickupPoint?.globalPickupPointId,
      selectedPickupPoint?.name,
      selectedStore?.globalStoreId,
      selectedStore?.name
    ]
  );
};
export {
  useMapShippingAddress
};
//# sourceMappingURL=use-map-shipping-address.js.map
